// React
import React from 'react';
import { Controller } from 'react-hook-form';
// material-ui components
import Divider from '@mui/material/Divider';
// custom components
import NumberedHeading from "../../../../../shared-components/forms/NumberedHeading";
import ImageAndTextSlideArray from '../shared/ImageAndTextSlideArray';
import EmentorArray from '../shared/EmentorArray';

const PEObservationEvent = (props) => {
  const { control, formState } = props.methods;
  const { errors } = formState;
  const { inputDir } = props;

  return (
    <div>
      <NumberedHeading number="1" title="Images" instructions="Using the controls below, please add slides for this page." required />
      <Controller
        control={control}
        name="content.core"
        render={({field}) => <ImageAndTextSlideArray inputDir={inputDir} {...{control, errors}} />}
      />

      <Divider className="my-16" />

      <NumberedHeading number="2" title="eMentor Notes" instructions="Using the controls below, add any supplemental content to this page" />

      <Controller
        control={control}
        name="content.eMentor"
        render={({ field }) => <EmentorArray {...{ control, errors }} />}
      />
    </div>
  );
};

export default PEObservationEvent;